import { useState, useEffect } from 'react';

export const useScreenReaderDetection = () => {
  const [isScreenReaderActive, setIsScreenReaderActive] = useState(false);

  useEffect(() => {
    // Simple screen reader detection based on accessibility preferences
    const checkScreenReader = () => {
      // Check for common accessibility settings that indicate screen reader usage
      const hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const hasHighContrast = window.matchMedia('(prefers-contrast: high)').matches;
      
      // On Mac/iOS, reduced motion is commonly enabled with VoiceOver
      const isApple = /Mac|iPhone|iPad/.test(navigator.userAgent);
      const likelyVoiceOver = isApple && hasReducedMotion;
      
      // On Windows, high contrast is commonly enabled with screen readers
      const isWindows = /Windows/.test(navigator.userAgent);
      const likelyNarrator = isWindows && hasHighContrast;
      
      setIsScreenReaderActive(likelyVoiceOver || likelyNarrator);
    };

    // Check on load and when preferences change
    checkScreenReader();
    
    // Listen for preference changes
    const mediaQueries = [
      window.matchMedia('(prefers-reduced-motion: reduce)'),
      window.matchMedia('(prefers-contrast: high)')
    ];
    
    const handleChange = () => checkScreenReader();
    
    mediaQueries.forEach(mq => {
      if (mq.addEventListener) {
        mq.addEventListener('change', handleChange);
      } else {
        mq.addListener(handleChange);
      }
    });

    return () => {
      mediaQueries.forEach(mq => {
        if (mq.removeEventListener) {
          mq.removeEventListener('change', handleChange);
        } else {
          mq.removeListener(handleChange);
        }
      });
    };
  }, []);

  return isScreenReaderActive;
};